const FORMAT_VALIDATIONS = Object.freeze({
  ONLY_ONE: (char, value) => {
    const regex = new RegExp(char, 'g');
    return (value.match(regex) || []).length < 2;
  },
  MAX_N_AFTER: (char, max, value) => (value.toString().split(char)[1]?.length ?? 0) <= max,
  MAX_N_BEFORE: (char, max, value) => (value.toString().split(char)[0]?.length ?? 0) <= max,
  CHAR_ONLY_AT_START: (char, pos, value) => value.indexOf(char) <= 0,
  ONLY_NEGATIVE_PREFIX: (value) => value.length === 1 && value === '-',
});

export default FORMAT_VALIDATIONS;
